import { Tooltip, TooltipContent, TooltipTrigger } from 'components';
import { useTranslation } from 'react-i18next';
import {
  InclusionInfoIcon,
  TooltipTriggerWrapper,
} from 'widgets/results/EbmProposals/EbmProposalToolTipMessage.styles';

export function EbmProposalToolTipMessage({ inclusionMessage }: { inclusionMessage?: string }) {
  const { t } = useTranslation();
  if (!inclusionMessage) return null;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <TooltipTriggerWrapper
          aria-label={t('result.ebmProposals.inclusionMessageTooltipAriaLabel')}
        >
          <InclusionInfoIcon />
        </TooltipTriggerWrapper>
      </TooltipTrigger>
      <TooltipContent>{inclusionMessage}</TooltipContent>
    </Tooltip>
  );
}
